export const FLOORPLAN = {
  AVAILABLE: {
    TH: 'ว่าง',
    EN: 'Available'
  },
  BUSY: {
    TH: 'ไม่ว่าง',
    EN: 'Busy'
  },
  SEARCH_BUILDING: {
    TH: 'อาคาร',
    EN: 'Building'
  },
  SEARCH_FLOOR: {
    TH: 'ชั้น',
    EN: 'Floor No.'
  },
  NO_BUILDING: {
    TH: 'กรุณาเลือกอาคารและชั้น',
    EN: 'Please select building and floor No.'
  },
  NO_IMAGE: {
    TH: 'ไม่พบภาพแผนผังชั้น',
    EN: 'No image found.'
  }
}
